import React, { useState } from 'react';
import { Button, Input } from '@material-tailwind/react';
import MaintenanceModal from './MaintenanceModal';
import { STATUS_META } from '../utils';

// Gate between a card leaving To Do and the status actually changing — a work order
// can't move into active work without a cost estimate attached. Mirrors
// CompleteWorkOrderModal, which does the same job for actual cost on Completed.
// Enforced here for the fast path, and again server-side as the real guarantee.
const EstimateGateModal = ({ isOpen, onClose, workOrder, targetStatus, onConfirm, isSubmitting }) => {
    const [estimate, setEstimate] = useState('');

    const handleClose = () => {
        setEstimate('');
        onClose();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (estimate === '') return;
        onConfirm(Number(estimate));
        setEstimate('');
    };

    if (!workOrder) return null;

    const targetLabel = STATUS_META[targetStatus]?.label || 'the next status';

    return (
        <MaintenanceModal isOpen={isOpen} onClose={handleClose} title="Enter Estimate to Continue" maxWidth="sm">
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <p className="text-sm text-[#6B675F]">
                    "<span className="font-semibold text-inv-ink">{workOrder.title}</span>" needs an estimate
                    before it can move to {targetLabel}.
                </p>
                <Input
                    type="number"
                    label="Estimate (PKR) *"
                    value={estimate}
                    onChange={(e) => setEstimate(e.target.value)}
                    min="0"
                    autoFocus
                />
                <div className="flex justify-end gap-2">
                    <Button variant="text" className="rounded-full" onClick={handleClose} type="button">Cancel</Button>
                    <Button
                        type="submit"
                        className="rounded-full bg-inv-brand shadow-none hover:bg-inv-brand-dark"
                        disabled={estimate === ''}
                        loading={isSubmitting}
                    >
                        Save &amp; Move to {targetLabel}
                    </Button>
                </div>
            </form>
        </MaintenanceModal>
    );
};

export default EstimateGateModal;
